import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Icon,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import {
  AutoCompleteWithTopLabel,
  DateSelectorWithTopLabelComponent,
  TextFieldWithTopLabelComponent,
} from '../../uiComponent/fhirComponentUi';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useDispatch, useSelector } from 'react-redux';
import { setProgress } from '../../../../redux/features/progressSlice';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../../MainUIFrame/MainFrame';

import {
  ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
} from '../../../MainUIFrame/constants';
import jwtDecode from 'jwt-decode';
import { ROLE_PROVIDER } from '../../../../pages/auth/constants';
import {
  CREATE_DYNAMIC_FORM,
  ehrAPIBaseService,
  ehrAPIServiceMeta,
} from '../../../../http-common';
import _ from 'lodash';

const ASK_TO_UPLOAD_OPTIONS_LIST = [
  {
    code: false,
    display: 'No',
  },
  { code: true, display: 'Yes' },
];

const TASK_OPTIONS_LIST = [
  { code: 'intakeForm', display: 'Intake Form' },
  { code: 'questionaireForm', display: 'Rating Scale Form' },
  { code: 'fillGenericForm', display: 'Fill Form' },
  { code: 'uploadDocuments', display: 'Upload Documents' },
  { code: 'other', display: 'Other' },
];

const TASK_QUESTIONAIRE_FORM_OPTION_LIST = [
  { display: 'Beck Anxiety Inventory', code: 'bai' },
  { display: 'Beck Depression Inventory', code: 'bdi' },
  { display: 'PHQ-9', code: 'phq-9' },
  { display: 'QIDS', code: 'qids' },
  { display: 'AIMS', code: 'aims' },
  { display: 'WHODAS', code: 'whodas' },
  { display: 'GAD-7', code: 'gad-7' },
  { display: 'Fagerstrom Test for Cigarette Dependence', code: 'ftcd' },
  { display: 'Columbia Suicide Severity Rating Scale', code: 'cssrs' },
  { display: 'LEC-5', code: 'lec-5' },
  { display: 'PCL-5', code: 'pcl-5' },
  { display: 'TASR-AM', code: 'tasr-am' },
  { display: 'CAGE', code: 'cage' },
  { display: 'CAGE-AID', code: 'cage-aid' },
];

const TASK_DOCUMENT_UPLOAD_OPTIONS_LIST = [
  { code: 'governmentId', display: 'Government Id' },
  { code: 'drivingLicense', display: 'Driving License' },
  { code: 'other', display: 'Other' },
];

const TASK_STATUS_LIST = [
  {
    code: 'requested',
    display: 'Requested',
  },
  {
    code: 'received',
    display: 'Received',
  },
  {
    code: 'accepted',
    display: 'Accepted',
  },
  {
    code: 'rejected',
    display: 'Rejected',
  },
  {
    code: 'ready',
    display: 'Ready',
  },
  {
    code: 'cancelled',
    display: 'Cancelled',
  },
  {
    code: 'in-progress',
    display: 'In Progress',
  },
  {
    code: 'on-hold',
    display: 'On Hold',
  },
  {
    code: 'failed',
    display: 'Failed',
  },
  {
    code: 'completed',
    display: 'Completed',
  },
  {
    code: 'entered-in-error',
    display: 'Entered in Error',
  },
];

const otherOptionsList = [{ code: 'other', display: 'Other' }];
const intakeForm = [{ code: 'intakeForm', display: 'Intake Form' }];

const UpdateSingleTaskRightDrawer = props => {
  const { task } = props;

  const reduxDispatch = useDispatch();

  const jwtPayload = jwtDecode(localStorage?.getItem(`jwtToken`));

  const [currentNoteValue, setCurrentNoteValue] = useState('');

  const [formsOptionsList, setFormsOptionList] = useState([]);

  const [errorMessage, setErrorMessage] = useState('');

  const [currentUser, setCurrentUser] = useState('');
  const [isFormCreated, setIsFormCreated] = useState(false);
  const { isRightDrawerOpen } = useMainFrameState();
  const dispatch = useMainFrameDispatch();

  useEffect(() => {
    if (task) {
      let taskTypeSingleSelect = task?.code?.coding?.find(item =>
        item?.system?.includes(`task-type`)
      );
      if (taskTypeSingleSelect?.code === 'fillGenericForm') {
        const formDataIdObject = task?.input?.find(
          item => item.type.coding[0].code === 'formDataId'
        );
        const valueString = formDataIdObject
          ? formDataIdObject.valueString
          : undefined;
        console.log(formDataIdObject, valueString);
        setIsFormCreated(Boolean(valueString));
      }
    }
  }, [task]);

  const [statusList, setStatusList] = useState([]);

  useEffect(() => {
    if (isFormCreated) {
      const tempForm = TASK_STATUS_LIST?.filter(item => {
        return item?.code !== 'requested';
      });
      setStatusList(tempForm);
    } else {
      setStatusList(TASK_STATUS_LIST);
    }
  }, [isFormCreated]);

  useEffect(() => {
    if (!isRightDrawerOpen) {
      setStatusList(TASK_STATUS_LIST);
    }
  }, [isRightDrawerOpen]);

  useEffect(() => {
    if (jwtPayload) {
      setCurrentUser(`Organization/${tenantOrganization?.id}`);

      if (jwtPayload?.enlivRoles?.includes(ROLE_PROVIDER)) {
        setCurrentUser(`Practitioner/${tenantPractitioner?.id}`);
      }
    }
  }, [jwtPayload]);

  dayjs.extend(utc);

  const getFormsList = async () => {
    try {
      reduxDispatch(setProgress(true));
      let params = {};
      params.offset = 0;
      params.limit = 10;
      const jwtPayload = jwtDecode(localStorage.getItem('jwtToken'));
      const tenantId = jwtPayload?.firebase?.tenant;
      const response = await ehrAPIServiceMeta.post(
        `${tenantId}/forms/form/list`,
        params,
        {
          headers: {
            'x-hasura-role': `admin`,
            'x-hasura-admin-secret': `c042293c-7ae1-43c5-bda1-fc3519f5fac2`,
          },
        }
      );

      let newList = response?.data?.Production_SLForm?.map(form => {
        return {
          code: form?.key,
          display: form?.formName,
          currentItem: form,
        };
      });

      console.log(newList);
      setFormsOptionList(newList);
    } catch (e) {
      console.error(e);
    } finally {
      reduxDispatch(setProgress(false));
    }
  };

  useEffect(() => {
    // getFormsList();
  }, []);

  const tenantPractitioner = useSelector(
    state => state?.current?.tenantPractitioner
  );

  const tenantOrganization = useSelector(
    state => state?.current?.tenantOrganization
  );

  const TASK_TO_SUBTASK_MAP = {
    questionaireForm: TASK_QUESTIONAIRE_FORM_OPTION_LIST,
    uploadDocuments: TASK_DOCUMENT_UPLOAD_OPTIONS_LIST,
    fillGenericForm: formsOptionsList,
    other: otherOptionsList,
    intakeForm: intakeForm,
  };

  const initialStateFromProps = props => {
    let taskTypeSingleSelect = task?.code?.coding?.find(item =>
      item?.system?.includes(`task-type`)
    );
    let subTaskSingleSelect = task?.code?.coding?.find(item =>
      item?.system?.includes(`sub-task-type`)
    );

    let dueDate = dayjs(task?.executionPeriod?.end)?.format();

    let tempVal = task?.extension?.find(item =>
      item?.url?.includes(`askToUpload`)
    )?.valueBoolean;
    let askToUploadDocuments = {
      display: tempVal ? 'Yes' : 'No',
      code: tempVal,
    };
    let status = {
      display: _.startCase(task?.status),
      code: task?.status,
    };

    return {
      taskTypeSingleSelect,
      subTaskSingleSelect,
      dueDate,
      askToUploadDocuments,
      annotationsNote: '',
      status,
    };
  };

  const [taskState, setTaskState] = useState(initialStateFromProps());

  const [annotationsList, setAnnotationsList] = useState(
    task?.note?.map(annotation => ({
      currentItem: annotation,
      text: annotation?.text,
      ownerName: annotation?.authorReference?.display,
      id: uuidv4(),
      isEdit: false,
      time: dayjs(annotation?.time)?.format(`MM/DD/YYYY HH:mm`),
    }))
  );

  const handleOnClick = async event => {
    const { name } = event?.target;

    if (name === 'setNote') {
      const { item } = event?.target?.value;
      let newList = [...annotationsList]?.map(currentItem => {
        if (currentItem?.id === item?.id) {
          return {
            ...currentItem,
            text: currentNoteValue,
            isEdit: !currentItem?.isEdit,
          };
        }
        return currentItem;
      });
      setAnnotationsList(newList);
    }
    if (name === 'updateAnnotations') {
      const myDate = new Date(taskState?.dueDate)?.valueOf();
      if (
        !(
          taskState?.taskTypeSingleSelect &&
          taskState?.subTaskSingleSelect &&
          !isNaN(myDate) &&
          !(myDate < 0) &&
          taskState?.status
        )
      ) {
        setErrorMessage('Please Fill All Mandatory * Fields.');
        return;
      } else {
        setErrorMessage('');
      }
      try {
        reduxDispatch(setProgress(true));
        let currentDateTime = dayjs()?.utc()?.format();

        debugger;

        let noteList = annotationsList?.length
          ? [...annotationsList]?.map(annotation => {
              let finalItem = {
                ...annotation?.currentItem,
                text: annotation?.text,
                time:
                  annotation?.text === annotation?.currentItem?.text
                    ? dayjs(annotation?.time)?.utc()?.format()
                    : currentDateTime,
              };

              return finalItem;
            })
          : [];

        if (taskState?.annotationsNote) {
          let authorReference = {};

          let roleList = jwtPayload?.enlivRoles?.filter(
            role => role !== ROLE_PROVIDER
          );
          authorReference.reference = `Organization/${tenantOrganization?.id}`;
          authorReference.display = `${tenantOrganization?.name} - ${
            roleList?.length > 0 && roleList?.[0]
          }`;

          if (jwtPayload?.enlivRoles?.includes(ROLE_PROVIDER)) {
            authorReference.reference = `Practitioner/${tenantPractitioner?.id}`;
            authorReference.display = `${tenantPractitioner?.name?.[0]?.text} - ${ROLE_PROVIDER}`;
          }

          noteList.push({
            authorReference,
            text: taskState?.annotationsNote,
            time: currentDateTime,
          });
        }

        const dueDateUtc = dayjs(taskState?.dueDate)?.utc()?.format();
        const newTask = {
          ...task,
          note: noteList,
          status: taskState?.status?.code,
          input: [],
          code: {
            coding: [
              {
                system: 'http://enliv.com/code/task-type',
                code: taskState?.taskTypeSingleSelect?.code,
                display: taskState?.taskTypeSingleSelect?.display,
              },
              {
                system: 'http://enliv.com/code/sub-task-type',
                code: taskState?.subTaskSingleSelect?.code,
                display: taskState?.subTaskSingleSelect?.display,
              },
            ],
          },
          executionPeriod: {
            end: dueDateUtc,
          },
          extension: [
            {
              url: 'http://enliv.com/fhir/StructureDefinition/askToUpload',
              valueBoolean: taskState?.askToUploadDocuments?.code,
            },
          ],
        };

        if (taskState?.taskTypeSingleSelect?.code === 'fillGenericForm') {
          try {
            reduxDispatch(setProgress(true));
            if (isFormCreated) {
              newTask.input = task?.input;
            } else {
              const formId = taskState?.subTaskSingleSelect?.code;
              // const { formId, formDataId } = await CREATE_DYNAMIC_FORM({
              //   formKey: taskState?.subTaskSingleSelect?.code,
              //   userId: task?.for?.reference?.replace(`Patient/`, ''),
              // });

              newTask.input.push(
                {
                  type: {
                    coding: [
                      {
                        system:
                          'http://enliv.com/code/sub-task-type/generic-form/form-key',
                        code: 'formKey',
                        display: 'Form Key',
                      },
                    ],
                    text: 'Form Data Id',
                  },
                  valueString: formId,
                },
                {
                  type: {
                    coding: [
                      {
                        system:
                          'http://enliv.com/code/sub-task-type/generic-form/form-data-id',
                        code: 'formDataId',
                        display: 'Form Data Id',
                      },
                    ],
                    text: 'Form Data Id',
                  },
                  valueString: '',
                }
              );
            }
          } catch (e) {
            console.error(e);
          } finally {
            reduxDispatch(setProgress(false));
          }
        }

        await ehrAPIBaseService.put(`fhir/updateResource`, newTask);
        props?.gridRefreshCallback();
        dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
      } catch (e) {
        console.error(e);
      } finally {
        reduxDispatch(setProgress(false));
      }
    }

    if (name === 'editToggle') {
      const { item } = event?.target?.value;
      setCurrentNoteValue(item?.text);
      const newList = [...annotationsList]?.map(currentItem => {
        if (currentItem?.id === item?.id) {
          return {
            ...currentItem,
            isEdit: !currentItem?.isEdit,
          };
        }
        return { ...currentItem, isEdit: false };
      });

      setAnnotationsList(newList);
    }
  };

  console.log(annotationsList, taskState);

  const InfiniteLoadAutocomplete = ({
    onChange,
    value,
    name,
    optionsList,
    disabled = false,
  }) => {
    const [options, setOptions] = useState(optionsList || []);
    const [loading, setLoading] = useState(false);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [limit, setLimit] = useState(20);
    const [open, setOpen] = useState(false);

    const jwtPayload = jwtDecode(localStorage.getItem('jwtToken'));
    const tenantId = jwtPayload?.firebase?.tenant;

    const fetchData = async () => {
      setLoading(true);

      let currentOffset = offset;
      try {
        const response = await ehrAPIServiceMeta.post(
          `${tenantId}/forms/form/list`,
          {
            offset: currentOffset,
            limit,
          },
          {
            headers: {
              'x-hasura-role': `admin`,
              'x-hasura-admin-secret': `c042293c-7ae1-43c5-bda1-fc3519f5fac2`,
            },
          }
        );
        if (response?.data?.Production_SLForm) {
          const newList = response.data.Production_SLForm.map(form => ({
            code: form?.key,
            display: form?.formName,
            currentItem: form,
          }));

          if (newList && newList.length === 0) {
            setHasMore(true);
          } else {
            setOptions(prevOptions => [...prevOptions, ...newList]);
            setOffset(prevOffset => prevOffset + limit);
            setLimit(prevLimit => prevLimit + 10);
            setHasMore(false);
          }
        } else {
          throw new Error('Unexpected response structure');
        }
      } catch (e) {
        console.error('Error fetching data: ', e);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      if (open) {
        // If autocomplete is open, fetch data
        fetchData();
      }
    }, [open]); // Dependency on open state

    const handleAutocompleteChange = (event, newValue) => {
      setHasMore(false);
      let newEvent = {
        target: {
          name: name,
          value: newValue,
        },
      };
      onChange(newEvent);
    };

    return (
      <Grid item xs={12}>
        <Typography sx={{ fontSize: '14px' }}>
          Type <font color="red">*</font>
        </Typography>
        <Autocomplete
          size="small"
          options={
            optionsList
              ? hasMore
                ? [...options, { endResult: true }]
                : options
              : options
          }
          getOptionLabel={option => {
            if (option.endResult) return 'End of the items';
            return option.display;
          }}
          renderOption={(props, option, { selected }) => {
            if (option.endResult) {
              return (
                <li
                  style={{
                    marginLeft: '15px',
                    pointerEvents: 'none',
                    color: '#387CA3',
                  }}
                >
                  End of the items
                </li>
              );
            }
            return <li {...props}>{option.display} </li>;
          }}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          value={value}
          onChange={handleAutocompleteChange}
          disabled={disabled}
          loading={loading}
          renderInput={params => (
            <TextField
              size="small"
              {...params}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& > fieldset': {
                    borderColor: 'textFieldColor',
                    borderWidth: 2,
                  },
                },
                '.MuiFormHelperText-root': {
                  fontSize: '14px',
                },
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          ListboxProps={{
            onScroll: async event => {
              if (loading || hasMore) return;
              const { scrollTop, clientHeight, scrollHeight } = event.target;
              if (scrollHeight - scrollTop === clientHeight) {
                fetchData();
              }
            },
          }}
        />
      </Grid>
    );
  };

  const handleOnChange = event => {
    const { name, value } = event?.target;

    if (name === 'taskTypeSingleSelect') {
      const isDocumentUpload = value?.display === 'Upload Documents';
      setTaskState({
        ...taskState,
        taskTypeSingleSelect: value,
        subTaskSingleSelect:
          value?.code === 'other'
            ? { code: 'other', display: 'Other' }
            : value?.code === 'intakeForm'
            ? { code: 'intakeForm', display: 'Intake Form' }
            : null,
        askToUploadDocuments: {
          code: isDocumentUpload ? true : false,
          display: isDocumentUpload ? 'Yes' : 'No',
        },
      });
    }

    if (name === 'subTaskSingleSelect') {
      setTaskState({ ...taskState, subTaskSingleSelect: value });
    }

    if (name === 'dueDate') {
      setTaskState({ ...taskState, dueDate: value });
    }

    if (name === 'askToUploadDocuments') {
      setTaskState({ ...taskState, askToUploadDocuments: value });
    }

    if (name === 'status') {
      setTaskState({ ...taskState, status: value });
    }

    debugger;
    if (name === 'annotationsNote') {
      setTaskState({ ...taskState, annotationsNote: value });
    }

    if (name === 'noteField') {
      const { item, currentValue } = value;
      let newList = [...annotationsList]?.map(currentItem => {
        if (currentItem?.id === item?.id) {
          return {
            ...currentItem,
            text: currentValue,
          };
        }
        return currentItem;
      });
      setAnnotationsList(newList);
    }
  };

  return (
    <>
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 60px)',
        }}
      >
        <Grid sx={{ flex: '1', overflow: 'auto', paddingBottom: '10px' }}>
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
            container
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: isRightDrawerOpen ? 'flex-start' : 'center',
                alignItems: 'center',
              }}
            >
              {isRightDrawerOpen ? (
                <IconButton
                  onClick={() => {
                    dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
                  }}
                >
                  <Icon>chevron_right</Icon>
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => {
                    dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
                  }}
                >
                  <Icon>chevron_left</Icon>
                </IconButton>
              )}
            </Box>
            <Typography color="primary" px={2} fontSize={20}>
              Update Task
            </Typography>
            <Grid container p={2} gap={2}>
              <Grid item sm={12}>
                <AutoCompleteWithTopLabel
                  name="taskTypeSingleSelect"
                  label="Task Type"
                  optionsList={TASK_OPTIONS_LIST}
                  value={taskState?.taskTypeSingleSelect}
                  onChange={handleOnChange}
                  validation={{
                    required: true,
                  }}
                  disabled={isFormCreated}
                />
              </Grid>
              {taskState?.taskTypeSingleSelect?.code !== 'other' &&
                taskState?.taskTypeSingleSelect?.code !== 'intakeForm' && (
                  <Grid item sm={12}>
                    {taskState?.taskTypeSingleSelect?.code ===
                      'fillGenericForm' && (
                      <InfiniteLoadAutocomplete
                        key={taskState?.taskTypeSingleSelect?.code}
                        label="Type"
                        optionsList={
                          taskState?.taskTypeSingleSelect?.code
                            ? TASK_TO_SUBTASK_MAP?.[
                                taskState?.taskTypeSingleSelect?.code
                              ]
                            : []
                        }
                        value={taskState?.subTaskSingleSelect}
                        name="subTaskSingleSelect"
                        onChange={handleOnChange}
                        disabled={isFormCreated}
                      />
                    )}

                    {taskState?.taskTypeSingleSelect?.code ===
                    'fillGenericForm' ? null : (
                      <AutoCompleteWithTopLabel
                        key={taskState?.taskTypeSingleSelect?.code}
                        label="Type"
                        optionsList={
                          taskState?.taskTypeSingleSelect?.code
                            ? TASK_TO_SUBTASK_MAP?.[
                                taskState?.taskTypeSingleSelect?.code
                              ]
                            : []
                        }
                        value={taskState?.subTaskSingleSelect}
                        name="subTaskSingleSelect"
                        onChange={handleOnChange}
                        validation={{
                          required: true,
                        }}
                        // disabled={true}
                      />
                    )}
                  </Grid>
                )}
              <Grid item sm={12}>
                <DateSelectorWithTopLabelComponent
                  name="dueDate"
                  value={taskState?.dueDate}
                  onChange={handleOnChange}
                  label="Due Date"
                  // disabled={true}
                  validation={{
                    required: true,
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <AutoCompleteWithTopLabel
                  name="askToUploadDocuments"
                  label={`Upload Documents`}
                  optionsList={ASK_TO_UPLOAD_OPTIONS_LIST}
                  value={taskState?.askToUploadDocuments}
                  onChange={handleOnChange}
                  disabled={
                    taskState?.taskTypeSingleSelect?.display ===
                    'Upload Documents'
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid item sm={12}>
                <AutoCompleteWithTopLabel
                  name="status"
                  label="Status"
                  optionsList={statusList}
                  onChange={handleOnChange}
                  value={taskState?.status}
                  validation={{
                    required: true,
                  }}
                />
              </Grid>
              {annotationsList?.length > 0 && (
                <Grid item sm={12}>
                  <Box variant="div">
                    <Typography color="primary">Annotations</Typography>
                  </Box>

                  {annotationsList?.map((item, idx) => {
                    return (
                      <Box variant="div" key={item?.id}>
                        <Box
                          display={'flex'}
                          justifyContent={'space-between'}
                          alignItems={'center'}
                          variant="div"
                        >
                          <Typography
                            sx={{ fontSize: '16px', fontWeight: '500' }}
                          >{`#${idx + 1} ${item?.ownerName}`}</Typography>
                          {item?.currentItem?.authorReference?.reference ===
                            currentUser && (
                            <IconButton
                              onClick={() =>
                                handleOnClick({
                                  target: {
                                    name: 'editToggle',
                                    value: { item },
                                  },
                                })
                              }
                            >
                              {item?.isEdit ? (
                                // <Icon sx={{ fontSize: '18px' }}>cancel</Icon>
                                <></>
                              ) : (
                                <Icon sx={{ fontSize: '18px' }}>edit</Icon>
                              )}
                            </IconButton>
                          )}
                        </Box>
                        <Box variant="div">
                          <Typography
                            color="textSecondary"
                            sx={{
                              fontSize: '14px',
                              marginTop: '-5px',
                              marginBottom: '5px',
                            }}
                          >
                            {item?.time}
                          </Typography>
                        </Box>
                        {!item?.isEdit ? (
                          <Box>
                            <Typography>{item?.text}</Typography>
                          </Box>
                        ) : (
                          <Box>
                            <TextFieldWithTopLabelComponent
                              label=""
                              value={currentNoteValue}
                              onChange={event =>
                                setCurrentNoteValue(event?.target?.value)
                              }
                            />
                            <Box display={'flex'} gap={2} my={1}>
                              <Button
                                onClick={() =>
                                  handleOnClick({
                                    target: {
                                      name: 'setNote',
                                      value: { item },
                                    },
                                  })
                                }
                                size="small"
                                variant="contained"
                                disabled={!currentNoteValue}
                              >
                                Save
                              </Button>
                              <Button
                                onClick={() =>
                                  handleOnClick({
                                    target: {
                                      name: 'editToggle',
                                      value: { item },
                                    },
                                  })
                                }
                                size="small"
                                variant="outlined"
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Box>
                        )}
                        <Divider />
                      </Box>
                    );
                  })}
                  {/* <List>
                  {task?.note?.map((annotation, idx) => {
                    return (
                      <ListItem>
                        <ListItemText
                          primary={annotation?.text}
                          secondary={
                            <Fragment>
                              <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                                {annotation?.authorReference?.display}
                              </Typography>
                              {' — ' +
                                dayjs(annotation?.time)?.format(`MM/DD/YYYY HH:mm`)}
                            </Fragment>
                          }
                        ></ListItemText>
                      </ListItem>
                    );
                  })}
                </List> */}
                </Grid>
              )}

              <Grid item sm={12}>
                <TextFieldWithTopLabelComponent
                  name="annotationsNote"
                  label="Note"
                  value={taskState?.annotationsNote}
                  onChange={handleOnChange}
                />
              </Grid>
              {/* <Grid item sm={12}>
                <Button
                  name="updateAnnotations"
                  onClick={handleOnClick}
                  variant="contained"
                >
                  Update Annotations
                </Button>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>

        <Grid sx={{ marginBottom: '-50px' }} py={1}>
          <Grid container px={2} spacing={1}>
            <Grid sm={12}>
              <Typography
                sx={{ textAlign: 'center', fontSize: '14px' }}
                color="error"
              >
                {errorMessage}
              </Typography>
            </Grid>
            <Grid item sm={12}>
              <Button
                name="updateAnnotations"
                onClick={handleOnClick}
                variant="contained"
                fullWidth
              >
                Update
              </Button>
            </Grid>
            <Grid item sm={12}>
              <Button
                onClick={() => {
                  dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
                }}
                variant="outlined"
                fullWidth
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default UpdateSingleTaskRightDrawer;
